import { crudGetManyReference } from 'react-admin';
import { useDispatch } from 'react-redux';

import usePath from './usePath';

const useCrudGetManyReference = (
  resource: string,
  target: string,
  id: string,
  options?: {
    sort?: { field: string; order: 'ASC' | 'DESC' };
    filters?: { [key: string]: any };
  }
) => {
  const {
    params: { page, perPage },
  } = usePath();

  const dispatch = useDispatch();
  return () =>
    dispatch(
      crudGetManyReference(
        resource,
        target,
        id,
        `${target}_${resource}@${target}_${id}`,
        { page, perPage },
        options?.sort ?? { field: 'id', order: 'DESC' },
        options?.filters ?? {}
      )
    );
};

export default useCrudGetManyReference;
